import { useEffect, useState } from 'react';
import { Feature, LineString } from '@turf/helpers';
import * as turf from '@turf/turf';
import _first from 'lodash/first';
import { DriverLocation } from '../../../../components/mapbox/mapbox-route-tracker/mapbox-route-tracker';
import { RouteLocation } from 'types/common.consts';

const useMapboxRouteInit = (
	initialRoute: RouteLocation[],
	routeIndex: number,
	mainSteps: number,
	driverLocation: DriverLocation
) => {
	const [route, setRoute] = useState<RouteLocation[]>([]);
	const [routeFeature] = useState<Feature<LineString>>({
		type: 'Feature',
		properties: {},
		geometry: {
			type: 'LineString',
			coordinates: [
				[initialRoute[routeIndex]?.lng, initialRoute[routeIndex]?.lat],
				[initialRoute[routeIndex + 1]?.lng, initialRoute[routeIndex + 1]?.lat]
			]
		}
	});

	const [profileImagePoint] = useState<GeoJSON.Feature<GeoJSON.Point>>({
		type: 'Feature',
		properties: {},
		geometry: {
			type: 'Point',
			coordinates: driverLocation
				? [driverLocation.lng, driverLocation.lng]
				: [_first(initialRoute)?.lng, _first(initialRoute)?.lat]
		}
	});

	const initRoute = () => {
		const arc = [];
		for (let i = 0; i < initialRoute.length - 1; i++) {
			routeFeature.geometry.coordinates = [
				[initialRoute[i].lng, initialRoute[i].lat],
				[initialRoute[i + 1].lng, initialRoute[i + 1].lat]
			];

			const lineDistance = turf.length(routeFeature);
			for (let j = 0; j < lineDistance; j += lineDistance / mainSteps) {
				const segment = turf.along(routeFeature, j);
				arc.push(segment.geometry.coordinates);
			}
		}
		routeFeature.geometry.coordinates = arc;
		const newRoute = [];
		for (let k = 0; k < arc.length; k++) {
			let calcInitialRouteIndex = Math.round(k / mainSteps);
			calcInitialRouteIndex =
				calcInitialRouteIndex >= initialRoute.length ? initialRoute.length - 1 : calcInitialRouteIndex;
			newRoute[k] = {
				lng: arc[k][0],
				lat: arc[k][1],
				happened_at: initialRoute[calcInitialRouteIndex].happened_at
			};
		}
		setRoute(newRoute);
	};

	useEffect(() => {
		initRoute();
	}, [initialRoute]);

	return { route, routeFeature, profileImagePoint };
};

export default useMapboxRouteInit;
